import { client } from './axiosClient';

export interface Changelog {
  client_id: string;
  created_at: string;
  external_user_uuid: string;
  role_id: number;
  role_name: string;
  user_id: number;
}

export const getChangelogs = async (
  company_id: string,
  type: 'account_number' | 'channel_booking_code' | 'client_datev_details',
  entityIds?: number[]
) => {
  const res = await client.get<Changelog[]>('/client/change-logs', {
    params: {
      company_id,
      type,
      entityIds: entityIds?.join(','),
    },
  });
  return res.data;
};
